module.exports = __webpack_public_path__ + "static/media/mock-ags2.ca22ec9c.png";